const InfoMiniIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
            <path d="M8.25 5.75H6.75V4.25H8.25M8.25 11.75H6.75V7.25H8.25M7.5 0.5C6.51509 0.5 5.53982 0.693993 4.62987 1.0709C3.71993 1.44781 2.89314 2.00026 2.1967 2.6967C0.790176 4.10322 0 6.01088 0 8C0 9.98912 0.790176 11.8968 2.1967 13.3033C2.89314 13.9997 3.71993 14.5522 4.62987 14.9291C5.53982 15.306 6.51509 15.5 7.5 15.5C9.48912 15.5 11.3968 14.7098 12.8033 13.3033C14.2098 11.8968 15 9.98912 15 8C15 7.01509 14.806 6.03982 14.4291 5.12987C14.0522 4.21993 13.4997 3.39314 12.8033 2.6967C12.1069 2.00026 11.2801 1.44781 10.3701 1.0709C9.46018 0.693993 8.48491 0.5 7.5 0.5Z" fill="#B8B8C4" />
        </svg>
    )
}

export default InfoMiniIcon